import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Clock, FileText, Lock } from "lucide-react";
import { api, errMsg, rupiah } from "@/lib/api";
import { Empty, Spinner } from "@/components/Brand";

export const PackageCard = ({ p }) => (
  <Link to={`/tryout/${p.id}`} className="card-premium flex flex-col p-6" data-testid={`package-card-${p.id}`}>
    <div className="flex items-start justify-between gap-3">
      <span className="text-xs font-bold uppercase tracking-widest text-slate-400">{p.category_name}</span>
      <span className={`rounded-full px-3 py-1 text-xs font-bold ${p.price > 0 ? "bg-[#0A192F] text-amber-300" : "bg-emerald-100 text-emerald-700"}`} data-testid="package-price-badge">
        {p.price > 0 && <Lock className="mr-1 inline h-3 w-3" />}{rupiah(p.price)}
      </span>
    </div>
    <h3 className="mt-3 font-display text-xl font-bold text-[#0A192F]">{p.name}</h3>
    <p className="mt-1 line-clamp-2 text-sm text-slate-500">{p.description}</p>
    <div className="mt-4 flex flex-wrap gap-1.5">
      {p.sections.map((s) => <span key={s.subject_id} className="rounded bg-slate-100 px-2 py-0.5 text-[11px] font-semibold text-slate-600">{s.code || s.name}</span>)}
    </div>
    <div className="mt-auto flex gap-5 pt-5 text-sm text-slate-600">
      <span className="flex items-center gap-1.5"><FileText className="h-4 w-4 text-amber-500" />{p.question_count} soal</span>
      <span className="flex items-center gap-1.5"><Clock className="h-4 w-4 text-amber-500" />{p.duration_minutes} menit</span>
    </div>
  </Link>
);

export default function Tryouts() {
  const [params, setParams] = useSearchParams();
  const cat = params.get("kategori") || "";
  const [cats, setCats] = useState([]);
  const [pkgs, setPkgs] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get("/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    setPkgs(null);
    api.get("/packages", { params: cat ? { category_id: cat } : {} }).then((r) => setPkgs(r.data)).catch((e) => setErr(errMsg(e)));
  }, [cat]);

  const chip = (id, label) => (
    <button key={id || "all"} onClick={() => setParams(id ? { kategori: id } : {})} data-testid={`filter-category-${id || "all"}`}
      className={`rounded-full px-4 py-2 text-sm font-semibold transition-colors ${cat === id ? "bg-[#0A192F] text-amber-300" : "bg-white text-slate-600 ring-1 ring-slate-200 hover:ring-amber-400"}`}>{label}</button>
  );

  return (
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
      <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-600">Daftar Tryout</p>
      <h1 className="mt-2 text-3xl font-extrabold text-[#0A192F] sm:text-4xl">Paket tryout tersedia</h1>
      <div className="mt-8 flex flex-wrap gap-2">{chip("", "Semua")}{cats.map((c) => chip(c.id, c.name))}</div>
      <div className="mt-8">
        {err ? <Empty text={err} /> : !pkgs ? <Spinner /> : pkgs.length === 0 ? <Empty text="Belum ada paket tryout aktif untuk kategori ini." testid="packages-empty" /> : (
          <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="packages-grid">{pkgs.map((p) => <PackageCard key={p.id} p={p} />)}</div>
        )}
      </div>
    </div>
  );
}
